import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  Inject,
  PLATFORM_ID,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import {CommonModule, DOCUMENT, isPlatformBrowser} from '@angular/common';
import {WordpressService} from "../../../services/wordpress.service";
import {WP_REST_API_Menu_item} from "../../../models/Wordpress/WP_REST_API_Menu_item";
import {LogoComponent} from "../logo/logo.component";
import {HeadMenuItemComponent} from "../../elements/head-menu-item/head-menu-item.component";
import {ActivatedRoute, EventType, Router, RouterLink} from "@angular/router";
import {environment} from "../../../../environments/environment";
import {SearchComponent} from "../search/search.component";
import {BookmarksService} from "../../../services/bookmarks.service";
import {ThemeService} from "../../../services/theme.service";

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule, LogoComponent, HeadMenuItemComponent, RouterLink, SearchComponent],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent implements AfterViewInit{
  public navigation: WP_REST_API_Menu_item[];
  public hasOverlay = false;
  public displayLanguages : boolean;
  public displaySearch : boolean = false;
  public textsearch : string = "";
  public scrolled : boolean = false;
  public bookmarksCount : number = 0;
  @ViewChild("header") headerRef : ElementRef;
  @ViewChild("search") searchRef : ElementRef;
  @ViewChild("nav") navRef : ElementRef;
  constructor(
    public themeService: ThemeService,
    public wp : WordpressService,
    private router: Router,
    public route: ActivatedRoute,
    @Inject(DOCUMENT) private doc: Document,
    private bookmarksService: BookmarksService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.wp.getMenuItems('main-menu').then((menu_items)=>{
      this.navigation = menu_items ?? [];
      this.setSearchOffset();
    });

    this.router.events.subscribe((e)=>{
      if(e.type == EventType.NavigationEnd){
        this.recursiveMenuHide(this.navigation);
        this.hasOverlay = false;
        this.displaySearch = false;
        this.doc.body.classList.remove("unscrollable");
        if(this.navRef?.nativeElement){
          this.navRef.nativeElement.classList.remove("open");
          this.navRef.nativeElement.style.height = 0;
        }
      }
      this.route.queryParams.subscribe((params)=>{
        if(params["s"]){
          this.textsearch = params["s"];
          this.displaySearch = true;
        }

      })
    });

    this.bookmarksService.bookmarks$.subscribe((b)=>{
      this.bookmarksCount = this.bookmarksService.count();
    })
  }

  ngAfterViewInit() {
    this.toggleScrolledClass(this.doc.body.clientTop);
  }

  onLanguageClick(slug:string){
    this.displayLanguages = false;
    const lang = this.themeService.languages.find((l)=>l.slug == slug);
    if(lang?.url){
      window.location.assign(lang.url);
    }
  }

  setSearchOffset(){
    const defaultHeight = 156;
    if(isPlatformBrowser(this.platformId)){
      if(window.scrollY == 0 && this.searchRef){
        this.searchRef.nativeElement.style.paddingTop = defaultHeight+"px";
      } else if(this.headerRef) {
        let newHeight = this.headerRef.nativeElement.clientHeight;
        this.searchRef.nativeElement.style.paddingTop = newHeight +"px";
      }
    } else {
      this.searchRef.nativeElement.style.paddingTop = defaultHeight+"px";
    }

  }

  onSearchClick(){
    this.displaySearch = true;
    this.setSearchOffset();
    this.doc.body.classList.add("unscrollable");
  }

  onDisplaySearchChange($event:boolean){
    this.displaySearch = $event;
    this.recursiveMenuHide(this.navigation);
    this.hasOverlay = false;
    if(!this.displaySearch){
      this.doc.body.classList.remove("unscrollable");
    } else {
      this.onSearchClick();
    }
  }

  onMenuResponsiveClick(){
    const nav = this.navRef.nativeElement;
    const isOpen = nav.classList.contains("open");
    if(!isOpen){
      nav.classList.add("open");
      this.doc.body.classList.add("unscrollable");
      nav.style.height = window.innerHeight -  this.headerRef.nativeElement.clientHeight+"px";
    } else {
      nav.classList.remove("open");
      this.doc.body.classList.remove("unscrollable");
      nav.style.height = 0;
    }

  }

  onNavItemChange(navItem:WP_REST_API_Menu_item){
    this.hasOverlay = false;
    this.recursiveMenuHide(this.navigation,navItem);
    setTimeout(()=>{
      this.hasOverlay = navItem.show;
    },50)
  }

  recursiveMenuHide(menu:WP_REST_API_Menu_item[], current?:WP_REST_API_Menu_item){
    if(menu){
      menu.forEach((i)=>{
        if(i.ID != current?.ID){
          i.show = false;
        }
        this.recursiveMenuHide(i.children);
      })
    }
  }

  toggleScrolledClass(offset : number){
    this.scrolled = offset > 0;
  }

  @HostListener('window:scroll', ['$event']) onWindowScroll($event: any) {
    const target = $event.currentTarget ;
    this.toggleScrolledClass(target.scrollY);
    this.setSearchOffset();
  }

  protected readonly environment = environment;
}
